import { Directive, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BasketItemComponentDef } from '@df/basket/view/basket-item.component.def';
import { IResponseRemoveFromBasket } from '@df/session/api/basket/basket.service';
import { GiftboxService } from './giftbox/giftbox.service';

declare module '@df/session/api/basket/basket-item' {
    interface IBasketItemData {
        /**
         * True if product is added as a free gift
         */
        is_free_gift?: boolean;
    }
}

@Directive()
export class BasketItemAbstract extends BasketItemComponentDef implements OnChanges {
    removed: boolean = false;

    giftboxService = inject(GiftboxService);

    @Input()
    basketFastCheckoutLoaded?: boolean;

    override ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj['basketFastCheckoutLoaded']) {
            this._ref.detectChanges();
        }
    }

    /**
     * Removes item from basket
     * @return {promise}
     */
    override checkoutRemove(): Promise<IResponseRemoveFromBasket> {
        const promise = super.checkoutRemove();
        promise.then(() => {
            this.removed = true;
            this._ref.detectChanges();
        });
        return promise;
    }

    get boxItemsCount(): number {
        return this.basket?.data?.gifting?.items?.length || 0;
    }

    get giftboxAvailable(): boolean {
        return this.app.data?.['giftboxesEnabled'] && !this.product?.data?.noGifting && this.basketFastCheckoutLoaded;
    }

    /**
     * If item can be edited
     */
    get isEditable(): boolean {
        return !this.item.data.is_free_gift;
    }
}
